import React from 'react';
import Registration from '../../components/Authorization/Registration';
import {cacheService} from "../../services/cacheService";
import SorryToSeeYouGo from "../../components/Popups/SorryToSeeYouGo";
import RegistrationBody from "../../components/RegistrationBody";
import TermsOfConditions from "../../components/Popups/TermsOfConditions";
import PrivacyPolicy from "../../components/Popups/PrivacyPolicy";
import {authStore} from "../../store/authStore";
import {observer} from "mobx-react-lite";
import CookiePolicy from "../../components/Popups/CookiePolicy";

const IllustrationWr = observer(() => {
    const isDeletedAccount = cacheService.get("DeletedAccount");
    const {termsPopup} = authStore;
    return (
        <>
            {isDeletedAccount && <SorryToSeeYouGo isDeletedAccount={isDeletedAccount}/>}
            {termsPopup === "terms" ? <TermsOfConditions/> : <></>}
            {termsPopup === "cookie" ? <CookiePolicy/> : <></>}
            {termsPopup === "privacy" ? <PrivacyPolicy/> : <></>}
            <RegistrationBody>
                <Registration/>
            </RegistrationBody>
        </>
    );
})

export default IllustrationWr;
